const enterInvalid = () => {
  document.onkeypress = function (e) { if (e.key === 'Enter') return false }
}
export default enterInvalid;